module.exports = "https://static.wagwalking.com/_next/static/images/petresource-dog-activities-1e745ff65983e1789cb6830c600909b1.svg";